import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { mockBackend } from '../services/mockBackend';
import { resolveBrowser, resolveDevice, resolveVisitorId } from '../utils/accessTracking';

const SiteAccessTracker = () => {
  const location = useLocation();

  useEffect(() => {
    mockBackend.analytics
      .trackPageView({
        path: location.pathname,
        referrer: document.referrer,
        visitorId: resolveVisitorId(),
        device: resolveDevice(),
        browser: resolveBrowser(),
      })
      .catch(() => undefined);
  }, [location.pathname]);

  return null;
};

export default SiteAccessTracker;
